import { createReducer } from './create';

const initialState = {
    state: 'idle',
    selected: false,
    choices: {
        meat: {val: 0, alias: ''},
        fish: {val: 0, alias: ''},
        veg: {val: 0, alias: ''},
    },
    time: null,
    is_loading_dinner: false,
    has_loaded_dinner: false,
    dinner: null,
    times: window.NOJESRESOR_PRODUCT != null
        ? NOJESRESOR_PRODUCT.dinner_times || []
        : [],
    selected_dinner: null,
    confirmed_dinner: null,
    show_dinner: false,
    step_dinner_done: true,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: () => {
        return initialState;
    },
    ['DINNER/SELECTED']: (state, payload) => {
        return Object.assign({}, state, {
            selected: payload,
        });
    },
    ['DINNER/CHOICES']: (state, payload) => {
        return Object.assign({}, state, {
            choices: payload,
        });
    },
    ['HOTELS/DESELECT']: state => {
        return Object.assign({}, state, {
            show_dinner: false,
            selected_dinner: null,
            confirmed_dinner: null,
            step_dinner_done: false,
            choices: {
                meat: {val: 0, alias: ''},
                fish: {val: 0, alias: ''},
                veg: {val: 0, alias: ''},
            },
            time: null,
        });
    },
    ['DINNER/SHOW']: state => {
        return Object.assign({}, state, {
            show_dinner: true,
            step_dinner_done: false,
        });
    },
    ['DINNER/LOAD']: state => {
        return Object.assign({}, state, {
            state: 'loading',
            is_loading_dinner: true,
            dinner: null,
        });
    },
    ['DINNER/LOAD_FINISHED']: (state, payload) => {
        return Object.assign({}, state, {
            state: 'loaded',
            is_loading_dinner: false,
            has_loaded_dinner: true,
            choices: {
                meat: {val: 0, alias: payload.menu.titles.meat},
                fish: {val: 0, alias: payload.menu.titles.fish},
                veg: {val: 0, alias: payload.menu.titles.veg},
            },
            dinner: payload,
            time: null,
            times: payload.times != null ? payload.times : state.times,
        });
    },
    ['DINNER/SELECT']: (state, payload) => {
        return Object.assign({}, state, {
            selected_dinner: {
                id: payload.id,
                meat: payload.meat,
                fish: payload.fish,
                veg: payload.veg,
                aliases: payload.aliases,
            },
        });
    },
    ['DINNER/SELECT_TIME']: (state, payload) => {
        return {...state, time: payload};
    },
    ['DINNER/DESELECT']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_dinner: null,
            selected_dinner: null,
            step_dinner_done: false,
            choices: {
                meat: {val: 0, alias: ''},
                fish: {val: 0, alias: ''},
                veg: {val: 0, alias: ''},
            },
        });
    },
    ['DINNER/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_dinner: {
                id: payload.id,
                time: payload.time,
                meat: payload.meat,
                fish: payload.fish,
                veg: payload.veg,
            },
            step_dinner_done: true,
            aliases: payload.aliases,
        });
    },
});
